"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsageAnalytics = exports.EventTypes = void 0;
var _actions = require("../actions");
var _ws = require("../constants/ws");
var _configureStore = _interopRequireDefault(require("../store/configureStore"));
var _browser = require("../../components/utils/browser");
const sendWSMessage = (instance = _ws.WEBSOCKETS.UA, trackDetails) => {
  _configureStore.default.instance.dispatch({
    type: instance === _ws.WEBSOCKETS.UA ? _actions.UA_MSG_SEND : _actions.WS_MSG_SEND,
    payload: trackDetails
  });
};
const EventTypes = exports.EventTypes = {
  NAVIGATION: 'Navigation',
  ACTION: 'Action',
  ERROR: 'Error'
};
class UsageAnalytics {
  static trackEvent(app, type, name, polyDetails, ...rest) {
    let browserInfo = this.browserInfoCache;
    if (!browserInfo) {
      browserInfo = (0, _browser.getBrowserInfo)();
    }
    let details = polyDetails;
    if (typeof details === 'string') {
      global.console.log('The signature of the method `trackEvent` has been changed. Please actualize the invocation of the method. The fallback will be removed in the next minor/major version.');
      details = rest[0] || {};
    }
    const trackDetails = {
      event_type: type,
      event_name: name,
      url: window.location.pathname,
      host: window.location.host,
      hash: window.location.hash,
      query: window.location.search,
      module: app,
      browser: browserInfo.name,
      browser_version: browserInfo.version,
      os: browserInfo.os,
      os_version: browserInfo.osVersion,
      is_mobile: browserInfo.platform === 'mobile' || browserInfo.platform === 'tablet',
      screen_resolution: browserInfo.resolution,
      ...details
    };
    UsageAnalytics.pushFunction(_ws.WEBSOCKETS.UA, trackDetails);
  }
  static trackHeapEvent(name, details = {}) {
    var _window$heap;
    if ((_window$heap = window.heap) !== null && _window$heap !== void 0 && _window$heap.loaded) {
      window.heap.track(name, {
        ...details
      });
    }
  }
}
exports.UsageAnalytics = UsageAnalytics;
UsageAnalytics.pushFunction = sendWSMessage;
UsageAnalytics.browserInfoCache = null;